import { ToastLevel } from '@src/common/components/ToastLevel';
import { Dropzone } from '@src/common/Dropzone';
import { useToast } from '@src/common/hooks/useToast';
import { useUploadDocument } from '@src/documents/hooks/useUploadDocument';
import type { FileWithPath } from 'react-dropzone';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

export const OrderDocumentUploader = ({
  orderId,
  onUploadSuccess,
}: {
  orderId: string;
  onUploadSuccess: () => void;
}) => {
  const { t } = useTranslation();

  const { showToast } = useToast();
  const { uploadDocument } = useUploadDocument({
    orderId,
    onSuccess: () => {
      onUploadSuccess();
      showToast({
        severity: ToastLevel.success,
        message: t('fileUpload.success'),
      });
    },
    onError: () => {
      showToast({
        severity: ToastLevel.error,
        message: t('fileUpload.error'),
      });
    },
  });

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop: (acceptedFiles) => onDrop(acceptedFiles),
  });

  const onDrop = (acceptedFiles: FileWithPath[]) => {
    acceptedFiles.forEach((file: FileWithPath) => {
      uploadDocument(file);
    });
  };

  return (
    <Dropzone
      isSmall={false}
      getRootProps={getRootProps}
      getInputProps={getInputProps}
      open={open}
      fileExtensionsMessage={t('fileExtensions')}
    />
  );
};
